import useSWR from 'swr'
import { API_BASE_URL } from 'config/api'
import { smartAuthenticatedFetcher, IError } from 'utils/fetchers'
import { ProductImage } from 'utils/imageUtils'

const apiUrl = `${API_BASE_URL}/customer/orders`

interface Product {
  image?: string | ProductImage // Old format: string, or Cart/Order format: ProductImage object
  images?: ProductImage[] // New format: array of image objects
  title: string
}

interface StatusHistoryType {
  status: string
  changedAt: string | number | Date
}

interface OrderItems {
  discount: number
  id: string
  orderId: string
  ownerId: string
  product: Product
  productId: string
  quantity: number
  price: number
  shipmentTrackingCode: number | null
  status: string
  statusHistory: StatusHistoryType[]
  subTotal: number
  total: number
  vat: number
}

interface Order {
  createdAt: string
  currency: string
  customerId: string
  discount: number
  id: string
  items: OrderItems[]
  receiverFirstName: string
  receiverLastName: string
  receiverTelephone: string
  shipmentTrackingCode: number | null
  shippingAddressCityId: number
  shippingAddressLatitude: number | null
  shippingAddressLongitude: number | null
  shippingAddressPostalCode: string
  shippingAddressText: string
  shippingPrice: number
  status: string
  statusHistory: StatusHistoryType[]
  subTotal: number
  total: number
  vat: number
}

export function useFetchOrder(id: string | undefined) {
  // Use smartAuthenticatedFetcher which handles token refresh automatically
  // No need to include token in cache key - fetcher handles auth internally
  const { data, error } = useSWR<Order, IError | null>(
    id ? `${apiUrl}/${id}` : null,
    smartAuthenticatedFetcher,
  )

  return {
    order: data,
    isLoading: !error && !data,
    isError: !!error,
    error: error,
  }
}
